<template>
  <div :busy="isLoading">
    <!-- <div :style="[!noInnerWidth ? { width: width } : {}]"> -->
    <div :style="{ width: !noInnerWidth ? width : 'auto' }">
      <div>
        <b-table
          :busy="isLoading"
          head-variant="light"
          :no-local-sorting="true"
          :items="items"
          :fields="getAllFields"
          :current-page="currentPage"
          per-page="0"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :sticky-header="height"
          no-border-collapse
          responsive
          show-empty
          empty-text="Non ci sono informazioni da mostrare"
          small
          @sort-changed="sortingChanged"
        >
          <template #table-busy>
            <table-skeleton />
          </template>
          <template #empty>
            <template>
              <empty-table
                :performedSearch="performedSearch"
                :automaticPerformedSearch="automaticPerformedSearch"
                :filterCount="filterCount"
              />
            </template>
          </template>
          <template #cell(cellphone)="{ item }">
            <div v-if="item['address_books']">
              {{ evaluateCellphone(item) }}
            </div>
            <span v-else>-</span>
          </template>
          <template #cell(phone)="{ item }">
            <div v-if="item['address_books']">
              {{ evaluatePhone(item) }}
            </div>
            <span v-else>-</span>
          </template>
          <template #cell(province)="{ item }">
            <div v-if="item['correspondences']">
              {{ evaluateProvince(item) }}
            </div>
            <span v-else>-</span>
          </template>
          <template #cell(city)="{ item }">
            <div v-if="item['correspondences']">
              {{ evaluateCity(item) }}
            </div>
            <span v-else>-</span>
          </template>
          <template #cell(mail)="{ item }">
            <div v-if="item['address_books']">
              {{ evaluateEmail(item) }}
            </div>
            <span v-else>-</span>
          </template>
          <template #cell(note_counter)="row" v-if="items.length">
            <div
              role="button"
              class="info-box float-left"
              @click="customOpenNoteModal(row.item, row.index, $event.target)"
              v-b-tooltip="
                toTooltipTask(
                  row.item.tasks.filter((task) => task.task_type.value === 2),
                  'Note',
                  [
                    { label: 'Titolo', key: 'title' },
                    { label: 'Descrizione', key: 'description' },
                    {
                      label: 'Ultimo aggiornamento',
                      key: 'last_update',
                      formatter: (val) => {
                        return moment(val).format('DD/MM/YYYY HH:mm:ss');
                      },
                    },
                    {
                      label: 'Creato da',
                      key: 'owner_id',
                      formatter: (val) => retriveOwner(val),
                    },
                    {
                      label: 'Data creazione',
                      key: 'created_at',
                      formatter: (val) => {
                        return moment(val).format('DD/MM/YYYY HH:mm:ss');
                      },
                    },
                  ]
                )
              "
            >
              {{
                row.item.tasks
                  ? row.item.tasks.filter((task) => task.task_type.value === 2).length
                  : 0,
              }}
            </div>
          </template>
          <template #cell(document_counter)="row" v-if="items.length">
            <div
              role="button"
              class="info-box float-left"
              @click="customOpenDocModal(row.item, row.index, $event.target)"
              v-b-tooltip="
                toTooltipTask(row.item.documents, 'Documenti', [
                  { label: 'Titolo', key: 'title' },
                  { label: 'Descrizione', key: 'note' },
                  {
                    label: 'Ultimo aggiornamento',
                    key: 'last_update',
                    formatter: (val) => {
                      return moment(val).format('DD/MM/YYYY HH:mm:ss');
                    },
                  },
                ])
              "
            >
              {{ row.item.documents ? row.item.documents.length : 0 }}
            </div>
          </template>
          <template #cell(todo_counter)="row" v-if="items.length">
            <div
              role="button"
              class="info-box float-left"
              @click="customOpenTodoModal(row.item, row.index, $event.target)"
              v-b-tooltip="
                toTooltipTask(
                  row.item.tasks.filter((task) => task.task_type.value === 1),
                  'Attività',
                  [
                    { label: 'Titolo', key: 'title' },
                    { label: 'Descrizione', key: 'description' },
                    {
                      label: 'Ultimo aggiornamento',
                      key: 'last_update',
                      formatter: (val) => {
                        return moment(val).format('DD/MM/YYYY HH:mm:ss');
                      },
                    },
                  ]
                )
              "
            >
              {{
                row.item.tasks.filter((task) => task.task_type.value === 1)
                  .length
              }}
            </div>
          </template>
          <template #cell(appointment_counter)="row" v-if="items.length">
            <div
              role="button"
              class="info-box float-left"
              @click="
                customOpenAppointmentModal(row.item, row.index, $event.target)
              "
              v-b-tooltip="
                toTooltipTask(
                  row.item.tasks.filter((task) => task.task_type.value === 0),
                  'Appuntamenti',
                  [
                    { label: 'Titolo', key: 'title' },
                    { label: 'Descrizione', key: 'description' },
                    {
                      label: 'Data e ora inizio',
                      key: 'started_at',
                      formatter: (val) => {
                        return moment(val).format('DD/MM/YYYY HH:mm:ss');
                      },
                    },
                    {
                      label: 'Data e ora fine',
                      key: 'ended_at',
                      formatter: (val) => {
                        return moment(val).format('DD/MM/YYYY HH:mm:ss');
                      },
                    },
                    {
                      label: 'Ultimo aggiornamento',
                      key: 'last_update',
                      formatter: (val) => {
                        return moment(val).format('DD/MM/YYYY HH:mm:ss');
                      },
                    },
                  ]
                )
              "
            >
              {{
                row.item.tasks.filter((task) => task.task_type.value === 0)
                  .length
              }}
            </div>
          </template>
          <template #cell(actions)="row">
            <div class="action-buttons">
              <b-button
                v-if="actions.includes('infomodal')"
                size="sm"
                variant="lisaweb"
                @click="openModal(row.item, row.index, $event.target)"
                class="mt-1 mr-1"
                :title="`Visualizza dettagli del contatto ${evaluateAgencyContactTitle(
                  row.item
                )}`"
              >
                <!-- <base-icon name="eye" width="22"></base-icon> -->
                <base-icon name="eye" width="22"></base-icon>
              </b-button>

              <b-button
                v-if="actions.includes('details')"
                size="sm"
                variant="lisaweb"
                @click="row.toggleDetails"
                class="mt-1 mr-1"
                :title="
                  row.detailsShowing ? 'Chiudi dettagli' : 'Apri dettagli'
                "
              >
                <b-icon v-if="row.detailsShowing" icon="chevron-up"></b-icon>
                <b-icon v-else icon="chevron-down"></b-icon>
              </b-button>

              <b-button
                v-if="actions.includes('edit')"
                size="sm"
                variant="lisaweb"
                @click="onEdit(row.item.id, row.item)"
                class="mt-1 mr-1"
                :title="`Modifica contatto ${evaluateAgencyContactTitle(
                  row.item
                )}`"
              >
                <!-- <base-icon name="edit" width="22"></base-icon> -->
                <base-icon name="edit" width="22"></base-icon>
              </b-button>
              <b-button
                v-if="actions.includes('destroy')"
                size="sm"
                variant="lisaweb"
                @click="
                  onDestroy(
                    row.item.id,
                    null,
                    `il contatto ${evaluateAgencyContactTitle(row.item)}`
                  )
                "
                class="mt-1 mr-1"
                :title="`Elimina contatto ${evaluateAgencyContactTitle(
                  row.item
                )}`"
              >
                <!-- <base-icon name="trash" width="22" height="22"></base-icon> -->
                <base-icon name="trash" width="22"></base-icon>
              </b-button>
            </div>
          </template>
          <template #cell(rowSelector)="row">
            <div class="action-buttons">
              <b-button
                size="sm"
                variant="lisaweb"
                @click="onChosen(row.item)"
                class="mt-1 mr-1"
                title="Seleziona"
              >
                Seleziona
              </b-button>
            </div>
          </template>
          <template #row-details="row">
            <b-card>
              <b-row
                class="mb-2"
                v-for="(value, key) in customized(row.item)"
                :key="key"
              >
                <b-col sm="3" class="text-sm-right"
                ><b>{{ key | capitalize }}:</b></b-col
                >
                <b-col>{{ value }}</b-col>
              </b-row>
            </b-card>
          </template>
          <template #cell()="{ value }">
            <span>{{ value }}</span>
          </template>
        </b-table>
      </div>
      <pagination-skeleton v-if="isLoading && !noPagination" />
      <div
        class="pagination-wrapper"
        v-if="!isLoading && !noPagination && items.length"
      >
        <div class="info">
          <div class="show-text">
            <p>
              <label for="per-page-select-registry"
              >Numero di risultati per pagina:</label
              >
            </p>
          </div>
          <div class="group">
            <b-form-group label-for="per-page-select">
              <b-form-select
                id="per-page-select-registry"
                v-model="perPage"
                :options="pageOptions"
                style="width: 68px"
                size="sm"
                @change="onPageChange(1)"
                :disabled="!items.length"
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="page">
            <p>
              Risultati da
              <strong>{{ formatItemsFrom }}</strong> a
              <strong>{{ formatItemsTo }}</strong> su un totale di
              <strong>{{ formatTotalItems }}</strong>
            </p>
          </div>
        </div>
        <div class="info-action">
          <div class="pagination" v-if="totalItems">
            <b-pagination
              v-model="currentPage"
              limit="3"
              :total-rows="totalItems"
              :per-page="perPage"
              size="sm"
              @change="onPageChange"
            >
              <template #page="{ page, active }">
                <span :data-active="active">{{
                    page.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                  }}</span>
              </template>
              <template v-slot:first-text>
                <span
                ><base-icon
                  scale="-1"
                  name="chevron_right_last_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
              <template v-slot:prev-text>
                <span
                ><base-icon
                  scale="-1"
                  name="chevron_right_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
              <template v-slot:next-text>
                <span
                ><base-icon
                  name="chevron_right_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
              <template v-slot:last-text>
                <span
                ><base-icon
                  name="chevron_right_last_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
            </b-pagination>
          </div>
          <div
            class="input_pagination"
            v-if="
              totalItems && !noInputPaginator && totalPages && totalPages > 3
            "
          >
            <base-input-pagination
              @pagination="onInputPagination"
            ></base-input-pagination>
          </div>
        </div>
      </div>
      <b-modal
        :id="infomodalName"
        @show="onModalShow"
        @hidden="onModalHidden"
        :title="modalTitle"
        size="xl"
        scrollable
        ok-only
        ok-title="Chiudi"
        ok-variant="-transparent"
        header-bg-variant="lisaweb"
        no-close-on-backdrop
      >
        <template v-slot:modal-header-close>
          <base-icon name="close" width="14" height="14"/>
        </template>
        <div>
          <b-tabs content-class="pt-1" lazy v-model="tabIndex">
            <b-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="setTab(tab, index)"
              :title="tab.text"
              :active="index === tabIndex"
              title-item-class="lisaweb"
            >
              <button-group-tab></button-group-tab>
              <keep-alive>
                <component
                  v-if="selected === tab.name"
                  :is="selected"
                  :resourceId="modalResourceId"
                  @fetch="fetch"
                ></component>
              </keep-alive>
            </b-tab>
          </b-tabs>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import template from "./template";
import BaseIcon from "@/components/BaseIcon";
import ButtonGroupTab from "@/components/ButtonGroupTab";
import Todo from "@/components/wallet/agency-contacts/details/Todo";
import General from "@/components/wallet/agency-contacts/details/General";
import Document from "@/components/wallet/agency-contacts/details/Documents";
import Notes from "@/components/wallet/agency-contacts/details/Notes";
import Appointments from "@/components/wallet/agency-contacts/details/Appointments";
import BaseInputPagination from "@/components/form/BaseInputPagination";
import {mapGetters} from "vuex";
import EmptyTable from "@/components/EmptyTable.vue";


export default {
  name: "AgencyContactsWalletTable",
  extends: template,
  data() {
    return {
      tabs: [
        {name: "General", text: "Generale"},
        {name: "Appointments", text: "Appuntamenti"},
        {name: "Notes", text: "Note"},
        {name: "Todo", text: "Attività"},
        {name: "Document", text: "Documenti"},
      ],
      selected: "General",
      modalResourceId: null,
      tabIndex: 0,
    };
  },
  props: {
    performedSearch: {
      type: Boolean,
      default: false,
    },
    filterCount: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  components: {
    BaseIcon,
    BaseInputPagination,
    General,
    Appointments,
    Notes,
    ButtonGroupTab,
    Todo,
    Document,
    EmptyTable,
  },
  methods: {
    evaluateCellphone(item) {
      const cell = this.toRelationString(
        "address_books",
        item.address_books,
        ["CELL"],
        [0]
      );
      return `${cell}` ? cell : "-";
    },
    evaluatePhone(item) {
      const phone = this.toRelationString(
        "address_books",
        item.address_books,
        ["PHON"],
        [0]
      );
      return `${phone}` ? phone : "-";
    },
    evaluateProvince(item) {
      const province = this.toRelationString(
        "correspondences",
        item.correspondences,
        ["VIRTUAL_CITY_PROVINCE"],
        [0]
      );
      return `${province}` ? province : "-";
    },
    evaluateCity(item) {
      const city = this.toRelationString(
        "correspondences",
        item.correspondences,
        ["CITY"],
        [0]
      );
      return `${city}` ? city : "-";
    },
    evaluateEmail(item) {
      const email = this.toRelationString(
        "address_books",
        item.address_books,
        ["MAIL"],
        [0]
      );
      return `${email}` ? email : "-";
    },
    freeSearch() {
      this.$emit("manualFetch");
    },
    evaluateAgencyContactTitle(item) {
      if (!Object.prototype.hasOwnProperty.call(item, "attributables"))
        return "-";
      return Object.prototype.hasOwnProperty.call(item.attributables, "CNAM")
        ? item.attributables.CNAM
        : Object.prototype.hasOwnProperty.call(item.attributables, "SURN") &&
        Object.prototype.hasOwnProperty.call(item.attributables, "NAME")
          ? `${item.attributables.SURN} ${item.attributables.NAME}`
          : "-";
    },
    customized() {
    },
    onModalShow() {
      if (this.tabIndex < this.tabs.length)
        this.setTab(this.tabs[this.tabIndex], this.tabIndex);
    },
    onModalHidden() {
      this.setTab({name: "General", text: "Generale"}, 0);
    },
    customOpenAppointmentModal(item, index, target) {
      this.tabIndex = 1; // TabIndex ID degli Appuntamenti
      this.openModal(item, index, target);
    },
    customOpenNoteModal(item, index, target) {
      this.tabIndex = 2; // TabIndex ID delle Note
      this.openModal(item, index, target);
    },
    customOpenTodoModal(item, index, target) {
      this.tabIndex = 3; // TabIndex ID delle Attività
      this.openModal(item, index, target);
    },
    customOpenDocModal(item, index, target) {
      this.tabIndex = 4; // TabIndex ID dei Documenti
      this.openModal(item, index, target);
    },
    retriveOwner(value) {
      if (!value) return "-";
      return (
        this.getUsers().find((user) => user.value === value)?.username ?? "-"
      );
    },
    ...mapGetters("auth", {
      getUsers: "users",
    }),
  },
  computed: {
    formatItemsFrom() {
      if (!this.totalItems) return "";
      return this.items_from.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatItemsTo() {
      if (!this.totalItems) return "";
      return this.items_to.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatTotalItems() {
      if (!this.totalItems) return "";
      return this.totalItems.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
};
</script>
